module.exports = __webpack_public_path__ + "static/media/pushbutton_green.516ea4ba.svg";